module.exports = __webpack_public_path__ + "img/1f1321bb-0542-45d0-9601-2a3d007d5842.64837cbc.jpg";